import { render, staticRenderFns } from "./async-routes-config.vue?vue&type=template&id=7e070df5&scoped=true&"
import script from "./async-routes-config.vue?vue&type=script&lang=js&"
export * from "./async-routes-config.vue?vue&type=script&lang=js&"
import style0 from "./async-routes-config.vue?vue&type=style&index=0&id=7e070df5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e070df5",
  null
  
)

export default component.exports